import { render, staticRenderFns } from "./Carprice.vue?vue&type=template&id=0ae751f5&scoped=true&"
import script from "./Carprice.vue?vue&type=script&lang=js&"
export * from "./Carprice.vue?vue&type=script&lang=js&"
import style0 from "./Carprice.vue?vue&type=style&index=0&id=0ae751f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae751f5",
  null
  
)

export default component.exports